var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4239 28.6815C27.191 28.9144 26.9231 29.0425 26.6204 29.0658C26.3176 29.0425 26.0498 28.9144 25.8169 28.6815L18.5504 21.415L11.3888 28.5767C11.1559 28.8096 10.888 28.9377 10.5853 28.961C10.2825 28.9377 10.0147 28.8096 9.78176 28.5767L8.66385 27.4588C8.43095 27.2259 8.3145 26.9697 8.3145 26.6902C8.3145 26.3641 8.43095 26.0847 8.66385 25.8518L15.8255 18.6901L8.76865 11.6333C8.53575 11.4004 8.4193 11.1442 8.4193 10.8647C8.4193 10.5387 8.53575 10.2592 8.76865 10.0263L9.99137 8.80355C10.2243 8.57065 10.4921 8.46585 10.7949 8.48914C11.0976 8.46585 11.3655 8.57065 11.5984 8.80355L18.6552 15.8604L25.8518 8.66381C26.0847 8.43091 26.3525 8.32611 26.6553 8.3494C26.9581 8.32611 27.2259 8.43091 27.4588 8.66381L28.5767 9.78173C28.8096 10.0146 28.9261 10.2941 28.9261 10.6202C28.9261 10.8996 28.8096 11.1558 28.5767 11.3887L21.3801 18.5853L28.6466 25.8518C28.8795 26.0847 28.9959 26.3641 28.9959 26.6902C28.9959 26.9697 28.8795 27.2259 28.6466 27.4588L27.4239 28.6815Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.fbf059f3f9e9c6ee3cf91fb8f3db182b.svg";
export { ForwardRef as ReactComponent };